<template>
  <div class="vouchers">
    <div class="vouchers__header">
      <h1 class="medium-title">All Voucher</h1>
      <div class="vouchers__header__menubar">
        <router-link class="subhead title" tag="li" :to="{name: 'voucherslist'}">All Voucher</router-link>
        <router-link class="subhead title" tag="li" :to="{name: 'vouchersredemptionlist'}">Redemption</router-link>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'adx-vouchers',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>